module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "r-container",
    class: {
      'is-loading': _vm.isLoading
    }
  }, [(_vm.isLoading) ? _c('relatorio-loading') : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide"
    }
  }, [(!_vm.isLoading) ? _c('div', {
    staticClass: "content-transition relatorio-print",
    attrs: {
      "id": "container-printer"
    }
  }, [_c('div', {
    staticClass: "hidden-print"
  }, [_c('div', {
    staticClass: "text-center m-t m-b-n"
  }, [_c('h3', {
    staticClass: "btn m-t-none",
    on: {
      "click": function($event) {
        _vm.showFiltros = !_vm.showFiltros
      }
    }
  }, [_c('span', {
    staticClass: "btn btn-default btn-xs m-r-xs"
  }, [_vm._v(_vm._s(!_vm.showFiltros ? '+' : '-'))]), _vm._v("Filtros")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFiltros),
      expression: "showFiltros"
    }],
    staticClass: "r-table"
  }, [_c('div', {
    staticClass: "r-table-content"
  }, [_c('div', {
    staticClass: "m-t"
  }, [_c('div', {
    staticClass: "m-b"
  }, [_c('div', [_vm._v("Tipo de Venda:")]), _vm._v(" "), _c('u-button-group', {
    attrs: {
      "options": _vm.tiposLeilao
    },
    model: {
      value: (_vm.filtro.tipo),
      callback: function($$v) {
        _vm.$set(_vm.filtro, "tipo", $$v)
      },
      expression: "filtro.tipo"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "m-b"
  }, [_c('div', [_vm._v("Situação:")]), _vm._v(" "), _c('u-button-group', {
    attrs: {
      "multiSelect": true,
      "options": _vm.situacaoLote
    },
    model: {
      value: (_vm.filtro.situacao),
      callback: function($$v) {
        _vm.$set(_vm.filtro, "situacao", $$v)
      },
      expression: "filtro.situacao"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "m-b"
  }, [_vm._v("\n                Resultados: " + _vm._s(_vm.filteredData && _vm.filteredData.length) + "\n              ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "hidden-print"
  }, [_c('h2', {
    staticClass: "text-center text-uppercase font-bold m-b-none"
  }, [_vm._v("Relatório de Saída de Bens")]), _vm._v(" "), _c('h4', {
    staticClass: "text-center text-uppercase"
  }, [_vm._v("Leilão Realizado " + _vm._s(_vm.moment(_vm.leilao.dataAbertura.date).format('LLLL')))])]), _vm._v(" "), _vm._l((_vm.filteredData), function(lote, key) {
    return _c('div', {
      staticClass: "printer-page pos-rlt"
    }, [_c('div', {
      staticClass: "visible-print"
    }, [_c('h2', {
      staticClass: "text-center text-uppercase font-bold m-b-none"
    }, [_vm._v("Relatório de Saída de Bens")]), _vm._v(" "), _c('h4', {
      staticClass: "text-center text-uppercase"
    }, [_vm._v("Leilão Realizado " + _vm._s(_vm.moment(_vm.leilao.dataAbertura.date).format('LLLL')))])]), _vm._v(" "), _c('div', {
      staticClass: "r-table"
    }, [_c('div', {
      staticClass: "r-table-header"
    }, [_c('div', {
      staticClass: "pull-left font-bold text-black"
    }, [_vm._v(_vm._s(lote.titulo))]), _vm._v(" "), _c('div', {
      staticClass: "pull-right font-bold"
    }, [_vm._v("Lote " + _vm._s(lote.numero))]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })]), _vm._v(" "), _c('div', {
      staticClass: "r-table-content"
    }, [_c('table', {
      staticClass: "w-full",
      attrs: {
        "cellpadding": "0",
        "cellspacing": "0"
      }
    }, [_c('tr', [_c('td', [_vm._v("Comitente: "), _c('strong', [_vm._v(_vm._s(lote.comitente.pessoa.nome))])]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v("Situação: "), _c('strong', {
      class: 'text-' + _vm.Status.Status[lote.status].class
    }, [_vm._v(_vm._s(_vm.Status.Status[lote.status].titulo))])])])]), _vm._v(" "), _c('div', {
      staticClass: "tab-border m-t-lg"
    }, [_c('table', {
      staticClass: "w-full table-arremate"
    }, [_c('thead', [_c('tr', [_c('th', [_vm._v("\n                    Valor de Arremate\n                  ")]), _vm._v(" "), _c('th', {
      staticStyle: {
        "width": "18%",
        "white-space": "nowrap"
      }
    }, [_vm._v("\n                    Situação do Arremate\n                  ")]), _vm._v(" "), _c('th', {
      staticStyle: {
        "width": "18%",
        "white-space": "nowrap"
      }
    }, [_vm._v("\n                    Mínimo\n                  ")]), _vm._v(" "), _c('th', {
      staticStyle: {
        "width": "18%",
        "white-space": "nowrap"
      }
    }, [_vm._v("\n                    Margem\n                  ")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [(lote.arremate) ? _c('span', [_vm._v("R$ " + _vm._s(_vm._f("moeda")(lote.valorArremate)))]) : _vm._e()]), _vm._v(" "), _c('td', [(lote.arremate) ? _c('span', [_vm._v(_vm._s(lote.arremate.statusString))]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v("\n                    R$ " + _vm._s(_vm._f("moeda")(lote.valorMinimo)) + "\n                  ")]), _vm._v(" "), _c('td', {
      staticClass: "margem"
    }, [(lote.arremate) ? _c('span', {
      class: _vm.bindMargemClass(lote.valorArremate, lote.valorMinimo)
    }, [_vm._v("R$ " + _vm._s(_vm._f("moeda")(Number(lote.valorArremate) - Number(lote.valorMinimo))))]) : _vm._e()])])])])]), _vm._v(" "), (lote.arremate) ? _c('div', {
      staticClass: "m-t"
    }, [_c('table', {
      staticClass: "w-full table table-bordered m-b-none"
    }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("Arrematante")]), _vm._v(" "), _c('td', {
      staticClass: "font-bold",
      attrs: {
        "colspan": "3"
      }
    }, [_vm._v(_vm._s(lote.arremate.arrematante.pessoa.nome) + "\n                    (" + _vm._s(lote.arremate.arrematante.apelido) + ") #A" + _vm._s(lote.arremate.arrematante.id) + "-P" + _vm._s(lote.arremate.arrematante.pessoa.id) + "\n\n                    ")])]), _vm._v(" "), (lote.arremate.arrematante.pessoa.tipo === 1) ? _c('tr', [_c('td', [_vm._v("Tratamento")]), _vm._v(" "), _c('td', {
      staticClass: "font-bold"
    }, [_vm._v(_vm._s(lote.arremate.arrematante.pessoa.pfTratamento))]), _vm._v(" "), _c('td', [_vm._v("Sexo")]), _vm._v(" "), _c('td', {
      staticClass: "font-bold"
    }, [_vm._v(_vm._s(lote.arremate.arrematante.pessoa.pfSexo === 1 ? 'M' : 'F'))])]) : _vm._e(), _vm._v(" "), (lote.arremate.arrematante.pessoa.tipo === 1) ? _c('tr', [_c('td', [_vm._v("CPF")]), _vm._v(" "), _c('td', {
      staticClass: "font-bold"
    }, [(lote.arremate.arrematante.pessoa.pfCpf) ? _c('span', [_vm._v(_vm._s(_vm._f("formataCpf")(lote.arremate.arrematante.pessoa.pfCpf)))]) : _c('span', [_vm._v("SEM CPF")])]), _vm._v(" "), _c('td', [_vm._v("RG")]), _vm._v(" "), _c('td', {
      staticClass: "font-bold"
    }, [_vm._v(_vm._s(lote.arremate.arrematante.pessoa.pfRg) + " " + _vm._s(lote.arremate.arrematante.pessoa.pfRgOrgaoEmissor) + "\n                  ")])]) : _vm._e(), _vm._v(" "), (lote.arremate.arrematante.pessoa.tipo === 1) ? _c('tr', [_c('td', [_vm._v("Data de Nascimento")]), _vm._v(" "), _c('td', {
      staticClass: "font-bold"
    }, [_vm._v(_vm._s(lote.arremate.arrematante.pessoa.pfDataNascimento ?
      _vm.moment(lote.arremate.arrematante.pessoa.pfDataNascimento.date).format('L') : '-') + "\n                  ")]), _vm._v(" "), _c('td', [_vm._v("Estado Civil")]), _vm._v(" "), _c('td', {
      staticClass: "font-bold"
    }, [_vm._v(_vm._s(lote.arremate.arrematante.pessoa.pfEstadoCivilString))])]) : _vm._e(), _vm._v(" "), (lote.arremate.arrematante.pessoa.tipo === 1 && (lote.arremate.arrematante.pessoa.pfFiliacaoNomePai || lote.arremate.arrematante.pessoa.pfFiliacaoNomeMae)) ? _c('tr', [_c('td', [_vm._v("Nome do Pai")]), _vm._v(" "), _c('td', {
      staticClass: "font-bold"
    }, [_vm._v(_vm._s(lote.arremate.arrematante.pessoa.pfFiliacaoNomePai))]), _vm._v(" "), _c('td', [_vm._v("Nome da Mãe")]), _vm._v(" "), _c('td', {
      staticClass: "font-bold"
    }, [_vm._v(_vm._s(lote.arremate.arrematante.pessoa.pfFiliacaoNomeMae))])]) : _vm._e(), _vm._v(" "), (lote.arremate.arrematante.pessoa.tipo === 2) ? _c('tr', [_c('td', [_vm._v("Razão Social")]), _vm._v(" "), _c('td', {
      staticClass: "font-bold"
    }, [_vm._v(_vm._s(lote.arremate.arrematante.pessoa.pjRazaoSocial ||
      lote.arremate.arrematante.pessoa.nome) + "\n                  ")]), _vm._v(" "), _c('td', [_vm._v("Nome Fantasia")]), _vm._v(" "), _c('td', {
      staticClass: "font-bold"
    }, [_vm._v(_vm._s(lote.arremate.arrematante.pessoa.pjNomeFantasia))])]) : _vm._e(), _vm._v(" "), (lote.arremate.arrematante.pessoa.tipo === 2) ? _c('tr', [_c('td', [_vm._v("CNPJ")]), _vm._v(" "), _c('td', {
      staticClass: "font-bold"
    }, [_vm._v(_vm._s(lote.arremate.arrematante.pessoa.pjCnpj))]), _vm._v(" "), _c('td', [_vm._v("Inscrição Estadual")]), _vm._v(" "), _c('td', {
      staticClass: "font-bold"
    }, [_vm._v(_vm._s(lote.arremate.arrematante.pessoa.pjInscricaoEstadual))])]) : _vm._e(), _vm._v(" "), (lote.arremate.arrematante.pessoa.tipo === 2) ? _c('tr', [_c('td', [_vm._v("Responsável")]), _vm._v(" "), _c('td', {
      staticClass: "font-bold"
    }, [_vm._v(_vm._s(lote.arremate.arrematante.pjProprietarioNome))]), _vm._v(" "), _c('td', [_vm._v("CPF")]), _vm._v(" "), _c('td', {
      staticClass: "font-bold"
    }, [(lote.arremate.arrematante.pjProprietarioCpf) ? _c('span', [_vm._v(_vm._s(_vm._f("formataCpf")(lote.arremate.arrematante.pjProprietarioCpf)))]) : _c('span', [_vm._v("SEM CPF DO RESPONSÁVEL")])])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_vm._v("IP Cadastro")]), _vm._v(" "), _c('td', {
      staticClass: "font-bold"
    }, [_vm._v(_vm._s(lote.arremate.arrematante.pessoa.ipCadastro))]), _vm._v(" "), _c('td', [_vm._v("Observação")]), _vm._v(" "), _c('td', {
      staticClass: "font-bold"
    }, [_vm._v(_vm._s(lote.arremate.arrematante.pessoa.observacao))])])])]), _vm._v(" "), _c('div', {
      staticClass: "tab-border no-border-top"
    }, [_c('table', {
      staticClass: "w-full table-arremate"
    }, [_c('thead', [_c('tr', [_c('th', [_vm._v("\n                      Endereço\n                    ")]), _vm._v(" "), _c('th', {
      staticStyle: {
        "width": "18%",
        "white-space": "nowrap"
      }
    }, [_vm._v("\n                      Cidade\n                    ")]), _vm._v(" "), _c('th', {
      staticStyle: {
        "width": "18%",
        "white-space": "nowrap"
      }
    }, [_vm._v("\n                      UF\n                    ")])])]), _vm._v(" "), _c('tbody', _vm._l((lote.arremate.arrematante.pessoa.enderecos), function(endereco) {
      return _c('tr', [_c('td', [_vm._v("\n                      " + _vm._s(endereco.logradouro) + ", " + _vm._s(endereco.numero) + " " + _vm._s(endereco.complemento) + ", " + _vm._s(endereco.bairro) + ", " + _vm._s(_vm._f("formataCep")(endereco.cep)) + "\n                    ")]), _vm._v(" "), _c('td', [_vm._v("\n                      " + _vm._s(endereco.municipio ? endereco.municipio.nome : endereco.cidadeOutros) + "\n                    ")]), _vm._v(" "), _c('td', [_vm._v("\n                      " + _vm._s(endereco.municipio && endereco.municipio.uf ? endereco.municipio.uf.nome : endereco.ufOutros) + "\n                    ")])])
    }), 0)])]), _vm._v(" "), _c('div', {
      staticClass: "tab-border no-border-top"
    }, [_c('table', {
      staticClass: "w-full table-arremate"
    }, [_c('thead', [_c('tr', [_c('th', [_vm._v("\n                      Email\n                    ")]), _vm._v(" "), _c('th', {
      staticStyle: {
        "width": "18%",
        "white-space": "nowrap"
      }
    }, [_vm._v("\n                      Finalidade\n                    ")])])]), _vm._v(" "), _c('tbody', _vm._l((lote.arremate.arrematante.pessoa.emails), function(email) {
      return _c('tr', [_c('td', [_vm._v("\n                      " + _vm._s(email.email) + "\n                    ")]), _vm._v(" "), _c('td', [_vm._v("\n                      " + _vm._s(email.finalidade ? email.finalidade.nome : '-') + "\n                    ")])])
    }), 0)])]), _vm._v(" "), _c('div', {
      staticClass: "tab-border no-border-top"
    }, [_c('table', {
      staticClass: "w-full table-arremate"
    }, [_c('thead', [_c('tr', [_c('th', [_vm._v("\n                      Telefone\n                    ")]), _vm._v(" "), _c('th', {
      staticStyle: {
        "width": "18%",
        "white-space": "nowrap"
      }
    }, [_vm._v("\n                      Finalidade\n                    ")])])]), _vm._v(" "), _c('tbody', _vm._l((lote.arremate.arrematante.pessoa.telefones), function(telefone) {
      return _c('tr', [_c('td', [_vm._v("\n                      " + _vm._s(_vm._f("formataTelefone")(telefone.telefone)) + "\n                    ")]), _vm._v(" "), _c('td', [_vm._v("\n                      " + _vm._s(telefone.finalidade ? telefone.finalidade.nome : '-') + "\n                    ")])])
    }), 0)])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "p-page-numer visible-print"
    }, [_vm._v("Página " + _vm._s(key + 1) + " de " + _vm._s(_vm.filteredData && _vm.filteredData.length))])])
  })], 2) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2b1a32d2","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/website/leiloes/components/RelatorioSaida.vue
// module id = 1590
// module chunks = 17